webpackJsonp([268472206294114],{

/***/ 49:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _P = __webpack_require__(11);
	
	var _P2 = _interopRequireDefault(_P);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ContactLink = function (_React$Component) {
	  _inherits(ContactLink, _React$Component);
	
	  function ContactLink(props) {
	    _classCallCheck(this, ContactLink);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = { mounted: false };
	    return _this;
	  }
	
	  ContactLink.prototype.componentDidMount = function componentDidMount() {
	    this.setState({ mounted: true });
	  };
	
	  ContactLink.prototype.render = function render() {
	    return _react2.default.createElement(
	      _P2.default,
	      { big: true },
	      'If you have any questions or feedback please',
	      ' ',
	      _react2.default.createElement(
	        'a',
	        {
	          href: this.state.mounted ? 'mailto:me%40gauti.info' : '#',
	          target: '_blank',
	          rel: 'noopener'
	        },
	        'email me.'
	      )
	    );
	  };
	
	  return ContactLink;
	}(_react2.default.Component);
	
	exports.default = ContactLink;
	module.exports = exports['default'];

/***/ }),

/***/ 232:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  background-image: url(', ');\n  background-repeat: no-repeat;\n  background-size: contain;\n  margin: 0;\n  padding-bottom: 85%;\n  position: relative;\n\n  img {\n    width: 100%;\n    left: 50%;\n    position: absolute;\n    top: 4.25%;\n    transform: translateX(-50%);\n    width: 92%;\n  }\n'], ['\n  background-image: url(', ');\n  background-repeat: no-repeat;\n  background-size: contain;\n  margin: 0;\n  padding-bottom: 85%;\n  position: relative;\n\n  img {\n    width: 100%;\n    left: 50%;\n    position: absolute;\n    top: 4.25%;\n    transform: translateX(-50%);\n    width: 92%;\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _desktop = __webpack_require__(510);
	
	var _desktop2 = _interopRequireDefault(_desktop);
	
	var _ResponsiveImg = __webpack_require__(34);
	
	var _ResponsiveImg2 = _interopRequireDefault(_ResponsiveImg);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var CompareMoviesDemo = _styledComponents2.default.figure(_templateObject, _desktop2.default);
	
	exports.default = function (_ref) {
	  var image = _ref.image,
	      otherProps = _objectWithoutProperties(_ref, ['image']);
	
	  return _react2.default.createElement(
	    CompareMoviesDemo,
	    null,
	    _react2.default.createElement('img', _extends({ src: image }, otherProps))
	  );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 53:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.NavigationLinksWrap = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  align-items: center;\n  display: flex;\n  justify-content: space-around;\n  list-style-type: none;\n  margin: 50px auto 25px;\n  max-width: 800px;\n  padding: 0;\n'], ['\n  align-items: center;\n  display: flex;\n  justify-content: space-around;\n  list-style-type: none;\n  margin: 50px auto 25px;\n  max-width: 800px;\n  padding: 0;\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  text-align: center;\n\n  a {\n    box-sizing: border-box;\n    color: ', ';\n    display: block;\n    font-size: 1.2rem;\n    line-height: 50px;\n    padding: 1rem 2rem;\n    transition: background-color 0.35s;\n    width: 170px;\n\n    &:before {\n      border: ', ';\n      border-width: 0 1px 1px 0;\n      content: \'\';\n      display: ', ';\n      margin-right: 15px;\n      padding: 5px;\n      transform: rotate(135deg) scale(2);\n      transition: transform 0.35s;\n    }\n\n    &:after {\n      border: ', ';\n      border-width: 0 1px 1px 0;\n      content: \'\';\n      display: ', ';\n      margin-left: 15px;\n      padding: 5px;\n      transform: rotate(-45deg) scale(2);\n      transition: transform 0.35s;\n    }\n\n    &:hover,\n    &:focus {\n      background-color: ', ';\n\n      &:before {\n        transform: rotate(135deg) scale(3);\n      }\n\n      &:after {\n        transform: rotate(-45deg) scale(3);\n      }\n    }\n  }\n'], ['\n  text-align: center;\n\n  a {\n    box-sizing: border-box;\n    color: ', ';\n    display: block;\n    font-size: 1.2rem;\n    line-height: 50px;\n    padding: 1rem 2rem;\n    transition: background-color 0.35s;\n    width: 170px;\n\n    &:before {\n      border: ', ';\n      border-width: 0 1px 1px 0;\n      content: \'\';\n      display: ', ';\n      margin-right: 15px;\n      padding: 5px;\n      transform: rotate(135deg) scale(2);\n      transition: transform 0.35s;\n    }\n\n    &:after {\n      border: ', ';\n      border-width: 0 1px 1px 0;\n      content: \'\';\n      display: ', ';\n      margin-left: 15px;\n      padding: 5px;\n      transform: rotate(-45deg) scale(2);\n      transition: transform 0.35s;\n    }\n\n    &:hover,\n    &:focus {\n      background-color: ', ';\n\n      &:before {\n        transform: rotate(135deg) scale(3);\n      }\n\n      &:after {\n        transform: rotate(-45deg) scale(3);\n      }\n    }\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyLink = __webpack_require__(22);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var NavigationLinksWrap = exports.NavigationLinksWrap = _styledComponents2.default.ul(_templateObject);
	
	var Li = _styledComponents2.default.li(_templateObject2, function (props) {
	  return props.theme.gray;
	}, function (props) {
	  return 'solid ' + props.theme.gray;
	}, function (props) {
	  return props.prev ? 'inline-block' : 'none';
	}, function (props) {
	  return 'solid ' + props.theme.gray;
	}, function (props) {
	  return props.prev ? 'none' : 'inline-block';
	}, function (props) {
	  return props.theme.grayLight;
	});
	
	var NavigationLinks = function NavigationLinks(_ref) {
	  var nextLink = _ref.nextLink,
	      nextCopy = _ref.nextCopy,
	      prevLink = _ref.prevLink,
	      prevCopy = _ref.prevCopy;
	  return _react2.default.createElement(
	    NavigationLinksWrap,
	    null,
	    !!nextLink && !!nextCopy && _react2.default.createElement(
	      Li,
	      { prev: true },
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: nextLink, title: 'Visit ' + nextCopy },
	        'Previous'
	      )
	    ),
	    !!prevLink && !!prevCopy && _react2.default.createElement(
	      Li,
	      null,
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: prevLink, title: 'Visit ' + prevCopy },
	        'Next'
	      )
	    )
	  );
	};
	
	NavigationLinks.propTypes = {
	  nextLink: _propTypes2.default.string,
	  nextCopy: _propTypes2.default.string,
	  prevLink: _propTypes2.default.string,
	  prevCopy: _propTypes2.default.string
	};
	
	exports.default = NavigationLinks;

/***/ }),

/***/ 509:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/compare-movies-demo.c0a903b3.gif";

/***/ }),

/***/ 69:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/compare-movies.fb04962c.jpg";

/***/ }),

/***/ 510:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/desktop.67f2d217.png";

/***/ }),

/***/ 247:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  margin: auto;\n  max-width: 700px;\n  padding: 0 10px;\n\n  p {\n    margin-bottom: 25px;\n  }\n'], ['\n  margin: auto;\n  max-width: 700px;\n  padding: 0 10px;\n\n  p {\n    margin-bottom: 25px;\n  }\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  text-align: center;\n'], ['\n  text-align: center;\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n  margin-right: 10px;\n'], ['\n  margin-right: 10px;\n']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\n  margin: 25px 0;\n\n  a {\n    margin: 10px;\n    width: 120px;\n  }\n'], ['\n  margin: 25px 0;\n\n  a {\n    margin: 10px;\n    width: 120px;\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _compareMoviesDemo = __webpack_require__(509);
	
	var _compareMoviesDemo2 = _interopRequireDefault(_compareMoviesDemo);
	
	var _DemoInsideMac = __webpack_require__(232);
	
	var _DemoInsideMac2 = _interopRequireDefault(_DemoInsideMac);
	
	var _Button = __webpack_require__(26);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Helmet = __webpack_require__(51);
	
	var _Helmet2 = _interopRequireDefault(_Helmet);
	
	var _H = __webpack_require__(27);
	
	var _H2 = _interopRequireDefault(_H);
	
	var _P = __webpack_require__(11);
	
	var _P2 = _interopRequireDefault(_P);
	
	var _Icon = __webpack_require__(52);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _Contact = __webpack_require__(49);
	
	var _Contact2 = _interopRequireDefault(_Contact);
	
	var _NavigationLinks = __webpack_require__(53);
	
	var _NavigationLinks2 = _interopRequireDefault(_NavigationLinks);
	
	var _compareMovies = __webpack_require__(69);
	
	var _compareMovies2 = _interopRequireDefault(_compareMovies);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var CompareMovies = _styledComponents2.default.article(_templateObject);
	
	var Header = _styledComponents2.default.header(_templateObject2);
	
	var GithubIcon = _styledComponents2.default.span(_templateObject3);
	
	var Buttons = _styledComponents2.default.div(_templateObject4);
	
	exports.default = function () {
	  return _react2.default.createElement(
	    'main',
	    null,
	    _react2.default.createElement(_Helmet2.default, {
	      title: 'Gowtham Selvaraj (Gauti) Project - Compare Movies - Compare Movies and TV Shows Instantly',
	      description: 'Compare Movies is a web app which compares movies and TV shows instantly. You can compare ratings from various sources (IMDB, Rotten Tomatoes, Metacritic and TMDB), awards info, DVD release dates, casts, crews, and so on. You can also watch trailers, videos, posters and other images all in one place.',
	      image: _compareMovies2.default,
	      path: '/projects/compare-movies'
	    }),
	    _react2.default.createElement(
	      CompareMovies,
	      null,
	      _react2.default.createElement(
	        Header,
	        null,
	        _react2.default.createElement(
	          _H2.default,
	          null,
	          'Compare Movies'
	        ),
	        _react2.default.createElement(
	          _P2.default,
	          { bigger: true },
	          'Compare Movies and TV Shows Instantly'
	        ),
	        _react2.default.createElement(
	          Buttons,
	          null,
	          _react2.default.createElement(
	            _Button2.default,
	            {
	              link: true,
	              bordered: true,
	              small: true,
	              href: 'https://www.comparemovies.info',
	              title: 'Visit comparemovies.info',
	              target: '_blank',
	              rel: 'noopener'
	            },
	            'Visit Project'
	          ),
	          _react2.default.createElement(
	            _Button2.default,
	            {
	              link: true,
	              bordered: true,
	              small: true,
	              href: 'https://github.com/gautiselvaraj/compare-movies',
	              title: 'Visit Compare Movies Github Repo',
	              target: '_blank',
	              rel: 'noopener'
	            },
	            _react2.default.createElement(
	              GithubIcon,
	              null,
	              _react2.default.createElement(_Icon2.default, { github: true })
	            ),
	            'Github'
	          )
	        )
	      ),
	      _react2.default.createElement(_DemoInsideMac2.default, {
	        src: _compareMoviesDemo2.default,
	        alt: 'Compare Movies and TV Shows Instantly'
	      }),
	      _react2.default.createElement(
	        _P2.default,
	        { big: true },
	        'Compare Movies is a web app which compares movies and TV shows instantly. You can compare ratings from various sources (IMDB, Rotten Tomatoes, Metacritic and TMDB), awards info, DVD release dates, casts, crews, and so on. You can also watch trailers, videos, posters and other images all in one place.'
	      ),
	      _react2.default.createElement(
	        _P2.default,
	        { big: true },
	        'I used React, Redux, Immutable.js and Next.js for compare movies. Next.js helps in server-side rendering of React applications. I wrote search/autocomplete, modal and image gallery components explicitly for compare movies. I utilized both TMDB and OMDB API to fetch movie and TV shows information. Finally, I used Google Cloud Platform\'s App Engine to host the app.'
	      ),
	      _react2.default.createElement(_Contact2.default, null)
	    ),
	    _react2.default.createElement(_NavigationLinks2.default, {
	      prevLink: '/projects/react-shorten/',
	      prevCopy: 'React Shorten',
	      nextLink: '/projects/nag-me/',
	      nextCopy: 'Nag Me'
	    })
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-projects-compare-movies-js-d0b472a5ae6f3e457402.js